import { Sparkle28Filled } from "@fluentui/react-icons";
import logo from "../../assets/logo_color_neg_optimized.png";

export const AnswerIcon = () => {
    return <img src={logo} aria-label="Answer logo" style={{ maxWidth: "70px", maxHeight: "70px" }} />;
};
